import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { StateService } from '../../core/services/state.service';

@Component({
    selector: 'app-state-page',
    imports: [RouterLink],
    templateUrl: './state-page.html',
    styleUrl: './state-page.scss',
})
export class StatePage implements OnInit {
    private route = inject(ActivatedRoute);
    private stateService = inject(StateService);
    stateCode = '';

    ngOnInit(): void {
        // Push the state code from the URL into the global StateService.
        // The <app-state> component in app.html will pick it up from there.
        this.stateCode = (this.route.snapshot.params['stateCode'] as string) ?? '';
        this.stateService.set(this.stateCode);
    }
}

